import React from 'react';
import PropTypes from 'prop-types';
import { CuiButton } from '../button';
import { CuiPanel } from '../panel';

export const CuiRedirectCallout = ({
  children,
  className,
  title,
  subTitle,
  ...rest
}) => (
  <CuiPanel
    color="success"
    padding="l"
    className={className}
    sections={[
      <div className="cuiRedirectCalloutSection" key="cta">
        <div className="cuiRedirectCallout__title">{title}</div>
        <div className="cuiRedirectCallout__subTitle">{subTitle}</div>
      </div>
    ]}
    {...rest}
  />
);

CuiRedirectCallout.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

CuiRedirectCallout.defaultProps = {
  children: undefined,
  className: undefined,
  title: undefined,
  subTitle: undefined,
};



// WEBPACK FOOTER //
// ./ui/components/redirectCallout/RedirectCallout.js